<template>
  <div
    :class="['socket', type, socket.name, used ? 'used' : '']"
    :title="socket.name"
  />
</template>

<script>
import VueRender from "rete-vue-render-plugin";

export default {
  extends: VueRender.Socket,
  props: ["used"]
};
</script>

<style lang="scss" scoped>
$socket-size: 12px;
$socket-margin: 10px;

.socket {
  display: inline-block;
  cursor: pointer;
  border: 2px solid;
  border-radius: 50%;
  width: $socket-size;
  height: $socket-size;
  // margin: $socket-margin !important;
  vertical-align: middle;
  background: transparent;
  position: relative;
  z-index: 2;
  border-color: var(--dividers_low_contrast) !important;

  &.Calculation {
    border-color: #f8c348;
    border-radius: 2px;
    &:hover {
      border-color: rgba(#f8c348, 0.3);
      background: rgba(#f8c348, 0.3);
    }
  }

  &.Sta {
    border-color: rgb(85, 183, 126);
  }

  &.SkimMatrix {
    border-color: rgb(255, 76, 141);
  }

  &.DemandMatrix {
    border-color: rgb(145, 94, 255);
  }

  &.used {
    background-color: var(--bg_panel_primary) !important;

    &.Calculation {
      background: #f8c348;
      border-color: #f8c348;
    }

    &.Sta {
      background: rgb(85, 183, 126);
    }

    &.SkimMatrix {
      background: rgb(255, 76, 141);
    }

    &.DemandMatrix {
      background: rgb(145, 94, 255);
    }
  }

  &:hover {
    border: 2px solid;
    border-color: var(--dividers_low_contrast) !important;
  }

  &.multiple {
    border-color: yellow;
  }
}
</style>
